import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Page, Shapeable } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { SliceLayoutBoundary, useEntity, useReady } from '@shapeable/ui';
import { classNames } from '@shapeable/utils';
const cls = classNames('page-layout-strategic-intelligence');
import { CampaignMonitorContactWidget } from '../elements/campaign-monitor-contact-widget';

// -------- Types -------->

export type SliceCampaignMonitorContactWidgetProps = Classable & HasChildren & { 
  entity?: Page;
};

export const SliceCampaignMonitorContactWidgetDefaultProps: Omit<SliceCampaignMonitorContactWidgetProps, 'entity'> = {
};

// -------- Child Component Props -------->

// -------- Styles -------->


const ContainerStyles = breakpoints({
  base: css`
  `,
});


const WidgetStyles = breakpoints({
  base: css`
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div`${ContainerStyles}`,
  
  Widget: styled(CampaignMonitorContactWidget)`${WidgetStyles}`,
};

export const SliceCampaignMonitorContactWidget: Shapeable.FC<SliceCampaignMonitorContactWidgetProps> = (props) => {
const { className } = props;
  const entity = useEntity(props.entity);

  // const t = useLang();

  const { isReady } = useReady();

  return (

    <My.Container className={cls.name(className)}>
      {/* <SliceLayoutBoundary> */}
        {
          isReady &&
          <My.Widget
          />
        }
    {/* </SliceLayoutBoundary> */}
    </My.Container>
  )

};

SliceCampaignMonitorContactWidget.defaultProps = SliceCampaignMonitorContactWidgetDefaultProps;
SliceCampaignMonitorContactWidget.cls = cls;